export const fromDirectory = (l) => {
  const m = (l.address || "").match(/^(\d+[A-Za-z]?)\s+([^,]+)/);
  const zip = l.zip || ((l.address || "").match(/\b(\d{5})(?:-\d{4})?\s*$/) || [])[1] || null;
  return {
    name: l.name, address: l.address || "", formatted_address: l.address || null,
    street_number: m ? m[1] : null, street_name: m ? m[2] : null, unit_number: null,
    city: l.city || null, county: null, state: l.state || "TX", zip_code: zip,
    lat: l.lat, lng: l.lng, place_id: l.place_id || `scoopz:${l.id}`, location_source: "directory",
    pin_adjusted: false, verified_at: new Date().toISOString(),
  };
};

export const GPS_ERRORS = {
  1: "Location permission was denied. Allow location access in your browser settings, or search for the address instead.",
  2: "Your GPS position is unavailable right now. Move to an open area or search for the address instead.",
  3: "Finding your location took too long. Try again or search for the address instead.",
};

export const placeLine = (p) => [p.unit_number && `Unit ${p.unit_number}`, p.formatted_address || p.address].filter(Boolean).join(" · ");

const near = (a, b) => Math.abs(a.lat - b.lat) < 0.0015 && Math.abs(a.lng - b.lng) < 0.0015;
export const inDirectory = (p, dir) => dir.some((l) => (l.place_id && l.place_id === p.place_id)
  || (l.lat != null && near(l, p) && l.name.toLowerCase() === p.name.toLowerCase()));
